export default __webpack_public_path__ + "static/media/89.a8e095ac.jpg";